<script>
export const group = 'Full'
</script>

<script setup>
import TextSlideUp from './text_animations/TextSlideUp.vue'
import CharacterEnlarge from './text_animations/CharacterEnlarge.vue'
import CharacterJumpFromTheRight from './text_animations/CharacterJumpFromTheRight.vue'
import { computed } from 'vue'
import { frames } from '../../../utils/frames'
import EFLoopAudioLevels02 from '../../../assets/animations/energetic_frequencies/loops/audio_levels_02.json'
import { colors } from '../../../tailwindTheme.config'
import ToFullTopLeft from './transitions/energetic_frequencies/ToFullTopLeft.vue'
import AnimatedBackground from '../../AnimatedBackground.vue'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const timelineSubtitle = ref(null)
const timelineSubtitleOut = ref(null)
const timelineTitle = ref(null)
const timelineNextAttempt = ref(null)

const answersListElement = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'EscapeRoomMostRecentAttemptSmall' })
    .add(timelineTitle)
    .add(timelineSubtitle, `<${frames(14)}`)
    .add(timelineNextAttempt, `<${frames(4)}`)
    .from(answersListElement.value.children, { xPercent: 100, opacity: 0, stagger: frames(2), ease: 'power2.out' }, '<')
})

const { onDisappear } = useDisappearable()
onDisappear(async () => {
  timelineTitle.value.reverse()
  timelineNextAttempt.value.reverse()

  await gsapTimeline({ name: 'EscapeRoomMostRecentAttemptSmall - End' })
    .add(timelineSubtitleOut.value(), '<')
    .add(timelineNextAttempt, '<')
    .add(timelineTitle, '<')
    .to(answersListElement.value.children, { xPercent: 100, opacity: 0, stagger: frames(2), ease: 'power2.in' }, '<')
})

const mostRecentAttempt = computed(() => item.enrichment.mostRecentAttempt)
const nextAttempt = computed(() => item.enrichment.nextAttempt)
</script>

<template>
  <ToFullTopLeft>
    <AnimatedBackground :lottie="EFLoopAudioLevels02" :scale="4" :position="{ x: -568, y: 0 }" :backgroundColor="colors.q.cr.red.primary" :color="colors.q.cr.red.darker">
      <div class="h-full flex items-center justify-center space-x-8">
        <div class="text-white space-y-12 w-[52rem]">
          <div class="text-white space-y-2 flex flex-col items-start">
            <div>
              <TextSlideUp :text="`De vorige poging`" class="text-8xl font-bold leading-none font-cervo" @timeline="timelineSubtitle = $event" @timelineOut="timelineSubtitleOut = $event" />
              <CharacterJumpFromTheRight :text="`Muzikale Code`" class="text-white mb-1" textSizeClass="text-9xl" @timeline="timelineTitle = $event" />
            </div>
            <CharacterEnlarge
              :text="nextAttempt ? `De volgende poging is ${nextAttempt.humanReadableDate}` : ''"
              class="text-white font-cervo font-bold text-[3rem]"
              @timeline="timelineNextAttempt = $event"
            />
          </div>
        </div>
        <div ref="answersViewportElement" class="w-[52rem]">
          <div ref="answersListElement" class="flex flex-col gap-6">
            <div v-for="answer in mostRecentAttempt.answers" :key="answer.contestantName" class="bg-white/90 rounded-xl text-6xl flex h-[160px]">
              <img :src="answer.contestantImageUrl" class="w-40 bg-red-400 object-cover" />
              <div class="p-6">
                <div class="line-clamp-1 font-bold pt-1">{{ answer.title }}</div>
                <div class="line-clamp-1">{{ answer.artist }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AnimatedBackground>
  </ToFullTopLeft>
</template>
